import { Component, OnInit } from '@angular/core';
import * as liquidGauge from "../../../libs/liquid/liquidFillGauge";
import * as $ from 'jquery';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
